import { WISHLIST_WIDGET_NAMES } from "@/constants/widget-names";
import { SdkEventInterface } from "@modules/sdk/events/SdkEventInterface";

import { WISHLISTS_SDK_EVENTS } from "../constants";

/**
 * Event dispatched when a wishlist item is added to the cart.
 * This event is used to track which widget initiated the add-to-cart action
 * and which product/variant was added.
 */
class WishlistItemAddedToCartSdkEvent implements SdkEventInterface {
    public readonly type = WISHLISTS_SDK_EVENTS.WISHLIST_ITEM_ADDED_TO_CART;

    /**
     * Creates a new WishlistItemAddedToCartSdkEvent
     * @param from - The widget that initiated the add-to-cart action (e.g. WISHLIST_DRAWER_WIDGET or WISHLIST_PAGE_WIDGET)
     * @param productId - The ID of the product being added to cart
     * @param variantId - The ID of the variant being added to cart
     */
    constructor(
        public readonly from: WISHLIST_WIDGET_NAMES,
        public readonly productId: number,
        public readonly variantId: number
    ) {}
}

export default WishlistItemAddedToCartSdkEvent;
